"use strict";

exports.__esModule = true;
exports.CommentTableWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _CommentTableElement = require("./CommentTableElement");
var _CommentTableFields = require("./CommentTableFields");
var _CommentTableThumbnail = require("./CommentTableThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CommentTableWidget = exports.CommentTableWidget = {
  name: "CommentTable",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "CommentTableWidget.label",
    defaultMessage: "Comment Table"
  }),
  icon: "comment",
  group: _widgetGroups.DIGITAL_LOG_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "CommentTable",
      props: Object.assign({
        width: 512,
        height: 512
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_CommentTableElement.CommentTableElement),
    Fields: _CommentTableFields.CommentTableFields,
    Thumbnail: _CommentTableThumbnail.CommentTableThumbnail
  }
};